<wr-building-section-select [building]="inspection.building"
                            [selectedSection]="selectedSection$|async"
                            (selectedSectionChange)="selectedSection$.next($event)">
</wr-building-section-select>
<wr-cover-page-customization *ngIf="selectedSection$ | async as selectedSection"
                             [selectedSection]="selectedSection" [formWrapper]="formWrapper"></wr-cover-page-customization>
